<template>
    <div>
        <input
            class="w-full max-w-lg px-6 py-3 rounded-full js-google-autocomplete bg-teal-lighter focus:outline-none focus:ring-2 focus:ring-teal-light"
            placeholder="Ex: 555 Broad Street"
        >
    </div>
</template>

<script>
export default {
    mounted() {
        const autocomplete = new google.maps.places.Autocomplete(document.querySelector(".js-google-autocomplete"));

        autocomplete.addListener('place_changed', () => {
            this.$emit('placeChanged', {center: autocomplete.getPlace().geometry.location});
        });
    },
};
</script>
